import React from "react";
import styles from "./styles/Beneficiary_trustee.module.css";
import deletingIcon from "./styles/img/deletable.png";
export function Beneficiarytrustee({
  name,
  priority,
  deleatable,
  onDelete,
  avatar,
  styling,
  textFontSize = "12px",
}) {
  let initials = "";
  name.split(" ")?.map((n) => (initials = initials + n[0]));

  var backgroundColor;
  switch (Number(priority)) {
    case 0:
      backgroundColor = "#26323E";
      break;
    case 1:
      backgroundColor = "#023E8A";
      break;
    case 2:
      backgroundColor = "#0077B6";
      break;
    default:
      backgroundColor = "#023E8A";
  }
  let extension;
  avatar && (extension = avatar[0]);
  if (extension === "/") extension = ".jpg";
  else if (extension === "i") extension = ".png";
  let avatarStyling = {};
  if (!avatar) {
    avatarStyling.backgroundColor = backgroundColor;
  }
  if (styling) {
    avatarStyling = { ...avatarStyling, ...styling };
  }
  return (
    <div
      title={name}
      data-priority={priority}
      className={styles.beneficiary_trustee}
      style={avatarStyling}
    >
      {avatar ? (
        <img
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
          }}
          src={`data:image/${extension};base64,${avatar}`}
          alt="avatar"
        />
      ) : (
        <span
          style={{
            overflow: "hidden",
            textWrap: "nowrap",
            fontSize: textFontSize,
          }}
        >
          {/* {initials.slice(0, 7)} */}
          {initials.length > 4 ? <>{initials.slice(0, 4)}...</> : initials}
        </span>
      )}

      {deleatable ? (
        <div onClick={onDelete}>
          <img
            src={deletingIcon}
            className={styles.deleatableContainer}
            alt="delete"
          />
          {/* <div className={styles.deleatable}></div> */}
        </div>
      ) : null}
    </div>
  );
}
